module.exports = {"messages":"Mensajes"}


//////////////////
// WEBPACK FOOTER
// ./src/translates/es/Messages.json
// module id = 607
// module chunks = 1